module.exports = __webpack_public_path__ + "img/branton-logo.7be11afe.svg";